import { graphql } from '../graphql';

export const clearanceProfilesQuery = graphql(`
  query ClearanceProfiles {
    clearanceProfiles {
      id
      name
      sourceAttribution
      vertices
      createdById
      createdAt
      updatedAt
    }
  }
`);

export const saveClearanceProfileMutation = graphql(`
  mutation SaveClearanceProfile($input: SaveClearanceProfileInput!) {
    saveClearanceProfile(input: $input) {
      id
      name
      sourceAttribution
      vertices
      createdById
      createdAt
      updatedAt
    }
  }
`);

export const deleteClearanceProfileMutation = graphql(`
  mutation DeleteClearanceProfile($id: ID!) {
    deleteClearanceProfile(id: $id)
  }
`);

export const startClearanceMutation = graphql(`
  mutation StartClearance($input: StartClearanceInput!) {
    startClearance(input: $input)
  }
`);
